import {
  AlertDetailPeople,
  AlertPeople,
  PeopleDetail,
  PeopleInformationSuggestion,
  PeopleProfileQuickView,
  PeopleProfiles,
  PeopleRelatedCompany,
  PeopleRelatedPeoples,
  EmailValidationPeople,
  EmailValidationPeopleDetail,
  PeopleIndustry,
} from 'src/model/people';
import { getBlobRequest, getRequest, postRequest } from 'src/services/api/http';
import { URL_ENDPOINT } from 'src/utils/constants/service';
import { handleQueryParams } from 'src/utils/helpers/queryParam';
import queryString from 'query-string';
import { CommonResponse } from 'src/model/common';

function getListPeople(query: string) {
  const url = URL_ENDPOINT.people.people + 'list-people?' + query;
  return getRequest(url, {}, new PeopleProfiles()) as Promise<PeopleProfiles>;
}

function getQuickViewPeopleProfile(id: string) {
  const url = URL_ENDPOINT.people.people + `quick-view/${id}`;
  return getRequest(url, {}, new PeopleProfileQuickView()) as Promise<PeopleProfileQuickView>;
}

function getPeopleDetail(id: string) {
  const url = URL_ENDPOINT.people.people + 'overview/' + id;
  return getRequest(url, {}, new PeopleDetail()) as Promise<PeopleDetail>;
}

function getPeopleRelatedCompany(id: string, params: Record<string, number>) {
  const url = URL_ENDPOINT.people.people + 'related-company/' + id;
  return getRequest(url, params, new PeopleRelatedCompany()) as Promise<PeopleRelatedCompany>;
}

function getPeopleRelatedPeople(id: string, params: Record<string, number>) {
  const url = URL_ENDPOINT.people.people + 'related-people/' + id;
  return getRequest(url, params, new PeopleRelatedPeoples()) as Promise<PeopleRelatedPeoples>;
}

function getPeopleInformationSuggestion(params: Record<string, string>, countryCode: string[]) {
  const queryCountry = handleQueryParams('country_code', countryCode);
  const url = `${URL_ENDPOINT.people.people}suggestions?${queryString.stringify(params)}&${queryCountry}`;
  return getRequest(url, {}, new PeopleInformationSuggestion()) as Promise<PeopleInformationSuggestion>;
}

function exportListPeople(query: string) {
  const url = URL_ENDPOINT.people.people + 'list-people/export?' + query;
  return getBlobRequest(
    url,
    {},
    {
      accept: 'application/json',
    },
  );
}

function getAlertPeople(id: string, param: Record<string, string | number>) {
  const url = URL_ENDPOINT.people.people + `alerts/${id}?`;
  return getRequest(url, param, new AlertPeople()) as Promise<AlertPeople>;
}

function getAlertDetailPeople({ peopleId, alertId }: { peopleId: string; alertId: string }) {
  const url = URL_ENDPOINT.people.people + `alerts/${peopleId}/${alertId}`;
  return getRequest(url, {}, new AlertDetailPeople()) as Promise<AlertDetailPeople>;
}

function getListEmailValidationPeople({
  peopleId,
  params,
}: {
  peopleId: string;
  params: Record<string, string | number>;
}) {
  const url = URL_ENDPOINT.people.people + `email-validation/${peopleId}`;
  return getRequest(url, params, new EmailValidationPeople()) as Promise<EmailValidationPeople>;
}

function recheckEmailValidation({ peopleId, emailId }: { peopleId: string; emailId: string }) {
  const url = URL_ENDPOINT.people.people + `email-validation/${peopleId}/re-check/${emailId}`;
  return getRequest(url, {}, new EmailValidationPeopleDetail()) as Promise<EmailValidationPeopleDetail>;
}

function getPeopleIndustry(countryCode: string[]) {
  const params = handleQueryParams('country_code', countryCode);
  const url = URL_ENDPOINT.company.commons + `industry/people?${params}`;
  return getRequest(url, {}, new PeopleIndustry()) as Promise<PeopleIndustry>;
}

function contributePeopleData(body: TypeDTOContributePeople) {
  const url = URL_ENDPOINT.people.people + 'contributions';
  return postRequest(url, body) as Promise<CommonResponse>;
}

const PeopleService = {
  getListPeople,
  getQuickViewPeopleProfile,
  getPeopleDetail,
  getPeopleRelatedCompany,
  getPeopleRelatedPeople,
  getPeopleInformationSuggestion,
  exportListPeople,
  getAlertPeople,
  getAlertDetailPeople,
  getListEmailValidationPeople,
  recheckEmailValidation,
  getPeopleIndustry,
  contributePeopleData,
};

export default PeopleService;
